// @flow

import ko from 'rgs-knockout';
import {JSable, createJSableEntityListMapExtender} from 'jsable';

import type { IMenuConfiguration } from 'app-my-navigation/types.flow';

const hasItems = (items: Array<any>) => (items || []).length;

class MenuItemParams extends JSable {
	Key = ko.observable('').extend({toJS: true, fromJS: true});
	Value = ko.observable('').extend({toJS: true, fromJS: true});
}

class MenuIcon extends JSable {
	static map (icon) {
		const attrs = icon.Attributes();

		return {
			attributes: (attrs || []).reduce(
				(prev, current) => ({...prev, ...mapIconAttr(current)}), {}),
		};
	}

	Attributes = ko.observableArray([])
		.extend(createJSableEntityListMapExtender(MenuItemParams, []));
}

export class MenuItem extends JSable {
	Icon = new MenuIcon();
	TabIcon = new MenuIcon();
	Title = ko.observable('').extend({toJS: true, fromJS: true});
	Key = ko.observable('').extend({toJS: true, fromJS: true});
	Url = ko.observable('').extend({toJS: true, fromJS: true});
	Items = ko.observableArray([])
		.extend(createJSableEntityListMapExtender(MenuItem, []));
	Attributes = ko.observableArray([])
		.extend(createJSableEntityListMapExtender(MenuItemParams, []));
}

export class MenuJSable extends JSable {
	static use (cfg: IMenuConfiguration) {
		return (URLDependencies: any, item: MenuItem) => {
			const {Url, Attributes, Items, Icon, TabIcon, ...rest} = item || {};

			const subItems = ko.unwrap(Items);
			const htmlLinkObservable = ko.observable('');

			const href = cfg.parseUrl(URLDependencies)(ko.unwrap(Url));
			const attrs = {
				...(hasItems(subItems) ? getAccessibleAttrs() : {}),
				...{href},
				...cfg.parseAttributes(ko.unwrap(Attributes)),
			};

			const mappedSubItems = subItems.map((subItem) => {
				const {Url, ...rest} = subItem || {};

				const href = cfg.parseUrl(URLDependencies)(ko.unwrap(Url));

				return {
					...rest,
					Url: href,
				};
			});

			return {
				...rest,
				Url: href,
				Items: mappedSubItems,
				Attributes: attrs,
				Icon: MenuIcon.map(Icon),
				TabIcon: MenuIcon.map(TabIcon),
				htmlLink: ko.pureComputed({
					read: htmlLinkObservable,
					write: value => {
						ko.computed(() => { //ONLY COMPUTED!! NOT PURE!
							htmlLinkObservable(ko.unwrap(value));
						});
					},
				}),
			};
		};
	}

	Items = ko.observableArray([])
		.extend(createJSableEntityListMapExtender(MenuItem, []));
}


function getAccessibleAttrs () {
	return {'aria-haspopup': true};
}


const instructor = {
	'className': {
		attrName: 'class',
		build: value => {
			const classes = value;

			return classes;
		},
	},
};

function mapIconAttr (attr) {
	const key = attr.Key();
	const value = attr.Value();

	const parser = instructor[key];

	return {
		[parser.attrName]: parser.build(value),
	};
}
